var exports = {
  "container": "SettingsModalLayout.module__container___cDdubm",
  "containerFullscreen": "SettingsModalLayout.module__containerFullscreen___cDdubm",
  "desktopSidebar": "SettingsModalLayout.module__desktopSidebar___cDdubm",
  "desktopSidebarInner": "SettingsModalLayout.module__desktopSidebarInner___cDdubm",
  "sidebarNavWrapper": "SettingsModalLayout.module__sidebarNavWrapper___cDdubm",
  "sidebarNav": "SettingsModalLayout.module__sidebarNav___cDdubm",
  "sidebarNavList": "SettingsModalLayout.module__sidebarNavList___cDdubm",
  "sidebarFooter": "SettingsModalLayout.module__sidebarFooter___cDdubm",
  "desktopScroll": "SettingsModalLayout.module__desktopScroll___cDdubm",
  "desktopScrollInner": "SettingsModalLayout.module__desktopScrollInner___cDdubm",
  "desktopContent": "SettingsModalLayout.module__desktopContent___cDdubm",
  "desktopContentPad": "SettingsModalLayout.module__desktopContentPad___cDdubm",
  "desktopContentCard": "SettingsModalLayout.module__desktopContentCard___cDdubm",
  "desktopHeader": "SettingsModalLayout.module__desktopHeader___cDdubm",
  "sidebarHeader": "SettingsModalLayout.module__sidebarHeader___cDdubm",
  "sidebarNavContent": "SettingsModalLayout.module__sidebarNavContent___cDdubm",
  "sidebarCategory": "SettingsModalLayout.module__sidebarCategory___cDdubm",
  "sidebarCategoryTitle": "SettingsModalLayout.module__sidebarCategoryTitle___cDdubm",
  "sidebarItem": "SettingsModalLayout.module__sidebarItem___cDdubm",
  "sidebarItemSelected": "SettingsModalLayout.module__sidebarItemSelected___cDdubm",
  "sidebarItemFocused": "SettingsModalLayout.module__sidebarItemFocused___cDdubm",
  "sidebarItemDanger": "SettingsModalLayout.module__sidebarItemDanger___cDdubm",
  "sidebarItemIcon": "SettingsModalLayout.module__sidebarItemIcon___cDdubm",
  "sidebarItemLabel": "SettingsModalLayout.module__sidebarItemLabel___cDdubm",
  "srOnly": "SettingsModalLayout.module__srOnly___cDdubm",
  "externalTabLabel": "SettingsModalLayout.module__externalTabLabel___cDdubm",
  "externalTabLabelText": "SettingsModalLayout.module__externalTabLabelText___cDdubm",
  "externalTabIcon": "SettingsModalLayout.module__externalTabIcon___cDdubm",
  "sidebarItemTrailing": "SettingsModalLayout.module__sidebarItemTrailing___cDdubm",
  "sidebarItemAttentionDot": "SettingsModalLayout.module__sidebarItemAttentionDot___cDdubm",
  "sidebarItemChevron": "SettingsModalLayout.module__sidebarItemChevron___cDdubm",
  "closeButton": "SettingsModalLayout.module__closeButton___cDdubm",
  "sidebarNavFooter": "SettingsModalLayout.module__sidebarNavFooter___cDdubm",
  "desktopScrollSpacerTop": "SettingsModalLayout.module__desktopScrollSpacerTop___cDdubm",
  "desktopScrollSpacerBottom": "SettingsModalLayout.module__desktopScrollSpacerBottom___cDdubm",
  "sidebarSubItemsWrap": "SettingsModalLayout.module__sidebarSubItemsWrap___cDdubm",
  "sidebarSubItems": "SettingsModalLayout.module__sidebarSubItems___cDdubm",
  "sidebarSubItem": "SettingsModalLayout.module__sidebarSubItem___cDdubm",
  "sidebarSubItemIndicator": "SettingsModalLayout.module__sidebarSubItemIndicator___cDdubm",
  "sidebarSubItemLabel": "SettingsModalLayout.module__sidebarSubItemLabel___cDdubm",
  "sidebarSubItemActive": "SettingsModalLayout.module__sidebarSubItemActive___cDdubm",
};

__webpack_require__.r(module.exports = exports);
